import React from 'react';
import { Switch } from 'react-router-dom';
import { localizeRoutePath } from '../../Pages/Helpers/localizeRoutePath';

// ##### Komarov 2025-07-14
const LocalizationSwitch = ({ children }) => {
  return (
    <Switch>
      {React.Children.map(children, children =>
        React.cloneElement(children, {
          ...children.props,
          path: localizeRoutePath(children.props.path),
        })
      )}
    </Switch>
  );
};

// ##### 25-05-21 Komarov
export default LocalizationSwitch;
